import { useTranslation } from 'react-i18next';

import { Button } from '@crm/shared/ui';

interface EmptyDealsPlaceholderProps {
    img: string;
    onReset?: () => void;
    title?: string;
    description?: string;
}

export const EmptyDealsPlaceholder = ({
    img,
    onReset,
    title,
    description,
}: EmptyDealsPlaceholderProps) => {
    const { t } = useTranslation();

    return (
        <div className="mx-auto flex max-w-88 flex-col items-center gap-6 pt-16">
            <img src={img} alt="" className="size-30" />
            <div className="flex w-fit max-w-full flex-col items-center gap-3">
                <h5 className="text-center text-lg leading-6 font-semibold whitespace-nowrap text-gray-800">
                    {title ?? t('crm.common.dealsTable.empty.filtered.title')}
                </h5>
                <p className="w-0 max-w-full min-w-full text-center text-xs [overflow-wrap:anywhere] text-gray-500">
                    {description ?? t('crm.common.dealsTable.empty.filtered.description')}
                </p>
            </div>
            {onReset && (
                <Button onClick={onReset}>{t('crm.common.dealsTable.empty.filtered.reset')}</Button>
            )}
        </div>
    );
};
